export const positiveNumberRegex = /^[0-9]+[.]{0,1}[0-9]{0,}$/

export function isPositiveNumberString(data: string): boolean {
  return !!data.match(positiveNumberRegex)
}